import { z } from 'zod/v4';

export const BulkUpdateTagsItemSchema = z.object({
  id: z.string().min(1),
  tagIds: z.array(z.string().min(1)),
});

export const BulkUpdateTagsRequestSchema = z
  .array(BulkUpdateTagsItemSchema)
  .min(1);

export type BulkUpdateTagsRequest = z.infer<typeof BulkUpdateTagsRequestSchema>;

export const BulkUpdateTagsResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateTagsResponse = z.infer<
  typeof BulkUpdateTagsResponseSchema
>;
